// Diccionario de traducciones ES/EN del sitio Salient.
// Estructura por sección/componente. Los arreglos (servicios, faqs, etc.)
// se combinan por índice con la metadata (íconos, rutas) en cada componente.

export const translations = {
    es: {
        nav: {
            inicio: 'Inicio',
            tecnologia: 'Tecnología',
            otrosServicios: 'Otros servicios',
            quienesSomos: 'Quienes somos',
            contactanos: 'Contáctanos',
            redes: 'Redes e Infraestructura',
            cctv: 'Videovigilancia y CCTV',
            software: 'Software y Consultoría',
            marketing: 'Marketing',
            energias: 'Energías Limpias',
            equipos: 'Venta de Equipos',
        },
        common: {
            solicitarAsesoria: 'Solicitar asesoría',
            conocerMas: 'Conocer más',
            cotizaSistema: 'Cotiza tu sistema',
            langLabel: 'English',
        },
        home: {
            hero: {
                titleLine1: 'HUB Global',
                titleLine2: 'de Tecnología',
                subtitle: 'Soluciones tecnológicas diseñadas para llevar a tu empresa al siguiente nivel.',
            },
            servicesHeader: {
                title: 'Nuestros Servicios Principales',
                intro: 'Soluciones integrales que transforman tu negocio desde la tecnología hasta la energía. Con un enfoque estratégico y personalizado, impulsamos la eficiencia, seguridad y crecimiento de tu empresa.',
            },
            services: [
                { title: 'Redes e Infraestructura', description: 'Diseñamos e implementamos infraestructura de red robusta y escalable para tu negocio.', features: ['Redes empresariales', 'Cableado estructurado', 'Data Center'] },
                { title: 'Videovigilancia y CCTV', description: 'Protegemos lo que más importa con sistemas de videovigilancia inteligentes y confiables.', features: ['Cámaras CCTV', 'Control de acceso', 'Monitoreo remoto'] },
                { title: 'Software y Consultoría', description: 'Optimizamos y automatizamos tus procesos con soluciones tecnológicas a la medida.', features: ['Migración de datos', 'Virtualización', 'Automatización'] },
                { title: 'Marketing Digital', description: 'Estrategias digitales que generan resultados medibles y posicionan tu marca.', features: ['Estrategia y campañas', 'Redes sociales', 'Posicionamiento web'] },
                { title: 'Energías Limpias', description: 'Impulsamos un futuro sostenible con soluciones de energía limpia y eficiente.', features: ['Energía solar', 'Ahorro energético', 'Sustentabilidad'] },
            ],
            process: {
                title: 'Cómo trabajamos contigo',
                subtitle: 'Un proceso simple y transparente desde el primer contacto hasta los resultados',
                steps: [
                    { title: 'Consulta inicial', description: 'Analizamos tus necesidades y objetivos específicos.' },
                    { title: 'Propuesta personalizada', description: 'Diseñamos una solución integral adaptada a tu negocio.' },
                    { title: 'Implementación', description: 'Ejecutamos el proyecto con nuestro equipo especializado.' },
                    { title: 'Seguimiento', description: 'Monitoreamos resultados y brindamos soporte continuo.' },
                ],
            },
            partners: {
                title: 'Nuestros socios comerciales',
                subtitle: 'Marcas y aliados que respaldan la calidad de nuestras soluciones.',
            },
            portfolio: {
                title: 'Portafolio de servicios',
                text: 'Descarga nuestro portafolio en PDF con el detalle de todos los servicios: redes, videovigilancia, software, marketing y energía.',
                button: 'Descargar PDF',
            },
            finalCta: {
                title: 'Atrae, cautiva y convierte: tu estrategia digital en manos expertas',
            },
        },
        about: {
            badge: 'Quiénes somos',
            title: '¿Quiénes somos?',
            introBefore: 'Salient es una empresa mexicana que integra tecnología, energía y marketing para impulsar el crecimiento de negocios y hogares en todo el país. Nuestra filosofía es clara:',
            introBold: ' hacer las cosas bien, con estrategia, eficiencia y corazón.',
            cta: 'Contáctanos',
            essenceTitle: 'Nuestra esencia',
            missionTitle: 'Misión',
            missionText: 'Impulsar el crecimiento de empresas e instituciones mediante soluciones integrales de ingeniería, infraestructura tecnológica, inteligencia artificial, automatización, energía y transformación digital, desarrolladas con innovación, calidad y un firme compromiso con generar resultados sostenibles para nuestros clientes.',
            visionTitle: 'Visión',
            visionText: 'Ser el hub tecnológico líder en Latinoamérica, reconocido por integrar ingeniería, innovación y tecnología de vanguardia para transformar organizaciones, impulsar su competitividad y contribuir al desarrollo sostenible de la región.',
            valuesTitle: 'Valores',
            values: ['Innovación', 'Ingeniería', 'Integridad', 'Compromiso', 'Excelencia', 'Confianza', 'Colaboración', 'Aprendizaje continuo', 'Sostenibilidad'],
        },
        contact: {
            badge: 'Contáctanos',
            title: 'Contáctanos',
            intro1: '¿Listo para transformar tu negocio? Agenda una consultoría gratuita y descubre cómo nuestras soluciones integrales en tecnología, marketing y energía pueden potenciar tu crecimiento.',
            intro2: 'Nuestro equipo de especialistas está aquí para ofrecerte un servicio personalizado, transparente y de alto valor.',
            infoTitle: 'Información de contacto',
            infoSubtitle: 'Estamos para ayudarte. Elige el medio que prefieras.',
            emailTitle: 'Correo electrónico',
            emailNote: 'Respuesta en menos de 24 horas',
            whatsappTitle: 'WhatsApp',
            whatsappNote: 'Escríbenos, respondemos rápido',
            followTitle: 'Síguenos',
            followNote: 'Novedades, proyectos y más',
            faqTitle: 'Preguntas frecuentes',
            faqs: [
                { q: '¿Cuánto tiempo toma recibir una respuesta?', a: 'Nos comprometemos a responder todos los mensajes en menos de 24 horas durante días laborales.' },
                { q: '¿La consultoría inicial tiene costo?', a: 'No, ofrecemos una consultoría inicial completamente gratuita para entender tus necesidades y proponer la mejor solución.' },
                { q: '¿Trabajan con empresas de cualquier tamaño?', a: 'Sí, atendemos desde emprendedores y pequeñas empresas hasta corporativos, adaptando nuestras soluciones a cada necesidad.' },
                { q: '¿Ofrecen soporte después de implementar las soluciones?', a: 'Absolutamente. Todos nuestros servicios incluyen soporte continuo y mantenimiento para asegurar el éxito de tu proyecto.' },
            ],
            ctaTitle: '¿Listo para comenzar?',
            ctaBefore: 'No esperes más para ',
            ctaBold: 'transformar tu negocio',
            ctaAfter: '. Contáctanos hoy y comencemos a trabajar juntos.',
            ctaButton: 'Escríbenos por WhatsApp',
        },
        marketing: {
            badge: 'Marketing y Branding',
            title: 'Marketing y Branding',
            subtitle: 'Construimos marcas sólidas y estrategias digitales que generan reconocimiento, posicionamiento y crecimiento comercial.',
            blocks: [
                { title: 'Branding Corporativo', subtitle: 'Identidad visual profesional', text: 'Creamos la identidad visual de tu empresa mediante diseño de logotipo, manual de identidad corporativa, papelería institucional, aplicaciones de marca y lineamientos gráficos para fortalecer tu posicionamiento y generar una imagen profesional y consistente.' },
                { title: 'Marketing Digital', subtitle: 'Publicidad que convierte', text: 'Facebook Ads, Instagram Ads y Google Ads. Diseñamos campañas estratégicas enfocadas en aumentar tu visibilidad, atraer clientes potenciales y maximizar la conversión con resultados medibles.' },
                { title: 'SEO y Automatización', subtitle: 'Visibilidad y eficiencia', text: 'Posicionamiento orgánico en buscadores, automatización de procesos comerciales e integración de herramientas digitales para incrementar la productividad y optimizar la experiencia del cliente.' },
                { title: 'CRM y Generación de Leads', subtitle: 'Convierte y escala', text: 'Implementación de CRM, administración de prospectos, diseño de embudos de venta y automatización comercial para convertir oportunidades en clientes y escalar el crecimiento de tu empresa.' },
            ],
            ctaTitle: 'Atrae, cautiva y convierte',
            ctaText: 'Tu estrategia digital en manos expertas. Impulsemos juntos el crecimiento de tu marca.',
            ctaLabel: 'Impulsa tu marca',
        },
        redes: {
            title: 'Redes e Infraestructura',
            subtitle: 'Diseñamos, instalamos y administramos redes seguras y de alto rendimiento, desde el cableado físico hasta el Data Center, adaptadas a las necesidades de cada empresa.',
            blocks: [
                { title: 'Redes Empresariales', subtitle: 'Soluciones de conectividad', items: ['Diseño e implementación de redes LAN, WAN y SD-WAN', 'Switching y Routing de alto desempeño', 'VLAN y segmentación de red', 'WiFi empresarial y movilidad', 'Calidad de servicio (QoS)', 'Alta disponibilidad y redundancia', 'Monitoreo y administración'] },
                { title: 'Cableado Estructurado', subtitle: 'Infraestructura física confiable', items: ['Cableado de voz y datos Cat5e, Cat6, Cat6a y Cat7', 'Fibra óptica monomodo y multimodo', 'Canalización y ductería', 'Certificación de puntos de red', 'Etiquetado y administración', 'Documentación profesional'] },
                { title: 'Infraestructura y Data Center', subtitle: 'Infraestructura crítica para alta disponibilidad', items: ['Diseño de cuartos de telecomunicaciones', 'Racks, gabinetes y accesorios', 'Energía regulada, UPS y PDU', 'Climatización y monitoreo ambiental', 'Modernización y expansión'] },
            ],
            ctaTitle: '¿Necesitas mejorar tu red o infraestructura?',
            ctaText: 'Nuestro equipo de especialistas diseña e implementa la solución de conectividad ideal para tu empresa.',
        },
        cctv: {
            title: 'Videovigilancia y CCTV',
            subtitle: 'Protege lo que más importa con sistemas de videovigilancia, control de acceso y alarmas, para hogares, negocios e industrias.',
            servicios: [
                { title: 'Instalación de cámaras (CCTV)', text: 'Instalación de cámaras de videovigilancia para hogares, negocios e industrias.' },
                { title: 'Venta de equipos de seguridad', text: 'Cámaras, DVR, NVR, monitores y accesorios.' },
                { title: 'Monitoreo remoto', text: 'Monitorea desde tu celular, tablet o computadora.' },
                { title: 'Mantenimiento', text: 'Mantenimiento preventivo y correctivo de sistemas de videovigilancia.' },
                { title: 'Actualización y modernización', text: 'Actualización y modernización de sistemas existentes.' },
                { title: 'Control de acceso', text: 'Sistemas de control de acceso con tarjetas, huella digital y reconocimiento facial.' },
                { title: 'Alarmas de seguridad', text: 'Instalación de alarmas contra robo e intrusión.' },
            ],
            ctaTitle: '¿Quieres proteger tu hogar o negocio?',
            ctaText: 'Te asesoramos para diseñar el sistema de videovigilancia y seguridad ideal para tu espacio.',
        },
        software: {
            title: 'Software y Consultoría',
            subtitle: 'Soluciones inteligentes que transforman tus operaciones tecnológicas. Asesoría experta en entornos empresariales complejos y soluciones de alto nivel.',
            serviciosTitle: 'Servicios destacados',
            servicios: [
                { title: 'Migración de datos y servidores', description: 'Traslado seguro de tu información sin interrumpir tus operaciones.' },
                { title: 'Virtualización de sistemas', description: 'Máquinas virtuales para optimizar el uso de tus recursos tecnológicos.' },
                { title: 'Automatización de procesos', description: 'Digitalizamos tareas repetitivas para mejorar la eficiencia operativa.' },
                { title: 'Consultoría en IBM y Oracle', description: 'Asesoría especializada en implementación, configuración y optimización.' },
            ],
            resultadosTitle: 'Resultados esperados',
            resultadosSubtitle: 'Beneficios tangibles que experimentarás al trabajar con nosotros.',
            resultados: [
                { title: 'Reducción de costos operativos', description: 'Optimizamos tus procesos para minimizar gastos y maximizar el retorno de inversión.' },
                { title: 'Mayor eficiencia tecnológica', description: 'Implementamos soluciones que aceleran tus operaciones y mejoran el rendimiento.' },
                { title: 'Infraestructura robusta y escalable', description: 'Bases sólidas que crecen con tu negocio y se adaptan a tus necesidades futuras.' },
            ],
            faqTitle: 'Preguntas frecuentes',
            faqs: [
                { q: '¿Cómo inicia el proceso de consultoría?', a: 'Comenzamos con una evaluación inicial de tus necesidades y objetivos. Luego diseñamos un plan personalizado que se ajuste a tu empresa y presupuesto.' },
                { q: '¿Cuánto tiempo toma implementar las soluciones?', a: 'El tiempo varía según la complejidad del proyecto. Típicamente, desde algunas semanas hasta varios meses para implementaciones más extensas.' },
                { q: '¿Ofrecen soporte post-implementación?', a: 'Sí, todos nuestros servicios incluyen un período de soporte técnico y asesoría continua para garantizar que las soluciones funcionen óptimamente.' },
                { q: '¿Trabajan con empresas de todos los tamaños?', a: 'Sí, adaptamos nuestras soluciones tanto para PyMEs como para grandes corporativos, ajustando el alcance y presupuesto según cada necesidad.' },
            ],
            ctaTitle: '¿Listo para optimizar tus operaciones tecnológicas?',
            ctaText: 'Agenda una consultoría personalizada y descubre cómo podemos ayudarte.',
        },
        energias: {
            badge: 'Otros servicios',
            title: 'Energías Limpias',
            subtitle: 'Energía solar para hogar, negocio e industria. Reduce tu recibo hasta 90% con ingeniería certificada y soluciones sostenibles.',
            sectionTitle: 'Servicios destacados',
            sectionSubtitle: 'Soluciones fotovoltaicas integrales: diseño, instalación, financiamiento y monitoreo.',
            servicios: [
                { title: 'Diseño a medida', text: 'Ingeniería y dimensionamiento según consumo y espacio.' },
                { title: 'Instalación certificada', text: 'Equipos y montajes con garantía y soporte técnico.' },
                { title: 'Financiamiento flexible', text: 'Opciones que se adaptan a tu presupuesto.' },
                { title: 'Monitoreo', text: 'Seguimiento en tiempo real del rendimiento del sistema.' },
            ],
            ctaButton: 'Cotiza tu sistema',
        },
        equipos: {
            badge: 'Otros servicios',
            title: 'Venta de Equipos y Consumibles',
            subtitle: 'Tu proveedor integral de tecnología: equipo de cómputo, videovigilancia, redes y consumibles, con asesoría experta y soporte.',
            sectionTitle: 'Nuestro catálogo',
            sectionSubtitle: 'Selección, suministro y renovación de equipo para tu empresa u hogar.',
            categorias: [
                { title: 'Equipo de cómputo', subtitle: 'Potencia para trabajar', items: ['Laptops y ultrabooks', 'PCs de escritorio', 'Workstations', 'Servidores', 'Monitores'] },
                { title: 'Videovigilancia y seguridad', subtitle: 'Protección confiable', items: ['Cámaras IP y analógicas', 'DVR y NVR', 'Control de acceso', 'Alarmas y accesorios'] },
                { title: 'Redes y conectividad', subtitle: 'Conexión sin límites', items: ['Switches y routers', 'Access points', 'Cableado y patch panels', 'Fibra óptica'] },
                { title: 'Consumibles', subtitle: 'Tu operación sin pausas', items: ['Tóners y cartuchos', 'Papel y etiquetas', 'Cables y adaptadores', 'Baterías', 'Medios de almacenamiento'] },
                { title: 'Accesorios y periféricos', subtitle: 'Todo lo que necesitas', items: ['Teclados y mouse', 'UPS / no-breaks', 'Discos duros y SSD', 'Memorias USB y RAM', 'Webcams y audio'] },
            ],
            benefitsTitle: '¿Por qué comprar con nosotros?',
            benefits: [
                { title: 'Asesoría experta', text: 'Te ayudamos a elegir el equipo correcto para tu necesidad y presupuesto.' },
                { title: 'Productos originales', text: 'Equipos y consumibles de marcas reconocidas.' },
                { title: 'Cotización a tu medida', text: 'Preparamos propuestas según lo que tu proyecto requiere.' },
                { title: 'Entrega y soporte', text: 'Instalación y soporte técnico post-venta.' },
            ],
            ctaTitle: '¿Necesitas equipar tu empresa?',
            ctaText: 'Cuéntanos qué necesitas y te preparamos una cotización a la medida.',
            ctaButton: 'Solicita tu cotización',
        },
        cookie: {
            textBefore: 'Usamos cookies para mejorar tu experiencia de navegación, analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en',
            acceptEmph: '“Aceptar”',
            textAfter: 'consientes su uso.',
            accept: 'Aceptar',
            reject: 'Rechazar',
        },
        footer: {
            tagline: 'Soluciones integrales para tu negocio que combinan tecnología, estrategia y energía.',
            techTitle: 'Tecnología',
            servicesTitle: 'Servicios',
            contactTitle: 'Contacto',
            redes: 'Redes e Infraestructura',
            cctv: 'Videovigilancia y CCTV',
            software: 'Software y Consultoría',
            marketing: 'Marketing Estratégico',
            energias: 'Energías limpias',
            equipos: 'Venta de Equipos',
            downloadPortfolio: 'Descargar portafolio (PDF)',
            quienesSomos: 'Quienes somos',
            contactanos: 'Contáctanos',
            rights: 'Todos los derechos reservados.',
        },
    },

    en: {
        nav: {
            inicio: 'Home',
            tecnologia: 'Technology',
            otrosServicios: 'Other services',
            quienesSomos: 'About us',
            contactanos: 'Contact',
            redes: 'Networks & Infrastructure',
            cctv: 'Video Surveillance & CCTV',
            software: 'Software & Consulting',
            marketing: 'Marketing',
            energias: 'Clean Energy',
            equipos: 'Equipment Sales',
        },
        common: {
            solicitarAsesoria: 'Request a consultation',
            conocerMas: 'Learn more',
            cotizaSistema: 'Get a quote',
            langLabel: 'Español',
        },
        home: {
            hero: {
                titleLine1: 'Global Technology',
                titleLine2: 'Hub',
                subtitle: 'Technology solutions designed to take your company to the next level.',
            },
            servicesHeader: {
                title: 'Our Core Services',
                intro: 'Comprehensive solutions that transform your business — from technology to energy. With a strategic, personalized approach, we drive your company\'s efficiency, security and growth.',
            },
            services: [
                { title: 'Networks & Infrastructure', description: 'We design and deploy robust, scalable network infrastructure for your business.', features: ['Enterprise networks', 'Structured cabling', 'Data Center'] },
                { title: 'Video Surveillance & CCTV', description: 'We protect what matters most with intelligent, reliable video surveillance systems.', features: ['CCTV cameras', 'Access control', 'Remote monitoring'] },
                { title: 'Software & Consulting', description: 'We optimize and automate your processes with tailor-made technology solutions.', features: ['Data migration', 'Virtualization', 'Automation'] },
                { title: 'Digital Marketing', description: 'Digital strategies that deliver measurable results and position your brand.', features: ['Strategy & campaigns', 'Social media', 'Web positioning'] },
                { title: 'Clean Energy', description: 'We drive a sustainable future with clean, efficient energy solutions.', features: ['Solar energy', 'Energy savings', 'Sustainability'] },
            ],
            process: {
                title: 'How we work with you',
                subtitle: 'A simple, transparent process from first contact to results',
                steps: [
                    { title: 'Initial consultation', description: 'We analyze your specific needs and goals.' },
                    { title: 'Tailored proposal', description: 'We design a comprehensive solution adapted to your business.' },
                    { title: 'Implementation', description: 'We execute the project with our specialized team.' },
                    { title: 'Follow-up', description: 'We monitor results and provide ongoing support.' },
                ],
            },
            partners: {
                title: 'Our business partners',
                subtitle: 'Brands and allies that back the quality of our solutions.',
            },
            portfolio: {
                title: 'Service portfolio',
                text: 'Download our PDF portfolio with the full detail of all our services: networks, video surveillance, software, marketing and energy.',
                button: 'Download PDF',
            },
            finalCta: {
                title: 'Attract, engage and convert: your digital strategy in expert hands',
            },
        },
        about: {
            badge: 'About us',
            title: 'Who we are',
            introBefore: 'Salient is a Mexican company that integrates technology, energy and marketing to drive the growth of businesses and homes across the country. Our philosophy is clear:',
            introBold: ' to do things right — with strategy, efficiency and heart.',
            cta: 'Contact us',
            essenceTitle: 'Our essence',
            missionTitle: 'Mission',
            missionText: 'To drive the growth of companies and institutions through comprehensive solutions in engineering, technology infrastructure, artificial intelligence, automation, energy and digital transformation — developed with innovation, quality and a firm commitment to generating sustainable results for our clients.',
            visionTitle: 'Vision',
            visionText: 'To be the leading technology hub in Latin America, recognized for integrating engineering, innovation and cutting-edge technology to transform organizations, boost their competitiveness and contribute to the region\'s sustainable development.',
            valuesTitle: 'Values',
            values: ['Innovation', 'Engineering', 'Integrity', 'Commitment', 'Excellence', 'Trust', 'Collaboration', 'Continuous learning', 'Sustainability'],
        },
        contact: {
            badge: 'Contact',
            title: 'Contact us',
            intro1: 'Ready to transform your business? Book a free consultation and discover how our comprehensive technology, marketing and energy solutions can boost your growth.',
            intro2: 'Our team of specialists is here to offer you personalized, transparent and high-value service.',
            infoTitle: 'Contact information',
            infoSubtitle: 'We\'re here to help. Choose the channel you prefer.',
            emailTitle: 'Email',
            emailNote: 'Reply within 24 hours',
            whatsappTitle: 'WhatsApp',
            whatsappNote: 'Message us — we reply fast',
            followTitle: 'Follow us',
            followNote: 'News, projects and more',
            faqTitle: 'Frequently asked questions',
            faqs: [
                { q: 'How long does it take to get a response?', a: 'We\'re committed to replying to all messages within 24 hours on business days.' },
                { q: 'Is the initial consultation free?', a: 'Yes — we offer a completely free initial consultation to understand your needs and propose the best solution.' },
                { q: 'Do you work with companies of any size?', a: 'Yes — we serve everyone from entrepreneurs and small businesses to large corporations, adapting our solutions to each need.' },
                { q: 'Do you offer support after implementing the solutions?', a: 'Absolutely. All our services include ongoing support and maintenance to ensure your project\'s success.' },
            ],
            ctaTitle: 'Ready to get started?',
            ctaBefore: 'Don\'t wait any longer to ',
            ctaBold: 'transform your business',
            ctaAfter: '. Contact us today and let\'s start working together.',
            ctaButton: 'Message us on WhatsApp',
        },
        marketing: {
            badge: 'Marketing & Branding',
            title: 'Marketing & Branding',
            subtitle: 'We build strong brands and digital strategies that generate recognition, positioning and commercial growth.',
            blocks: [
                { title: 'Corporate Branding', subtitle: 'Professional visual identity', text: 'We create your company\'s visual identity through logo design, brand identity manuals, corporate stationery, brand applications and graphic guidelines to strengthen your positioning and project a professional, consistent image.' },
                { title: 'Digital Marketing', subtitle: 'Advertising that converts', text: 'Facebook Ads, Instagram Ads and Google Ads. We design strategic campaigns focused on increasing your visibility, attracting leads and maximizing conversion with measurable results.' },
                { title: 'SEO & Automation', subtitle: 'Visibility and efficiency', text: 'Organic search engine positioning, sales process automation and integration of digital tools to boost productivity and optimize the customer experience.' },
                { title: 'CRM & Lead Generation', subtitle: 'Convert and scale', text: 'CRM implementation, lead management, sales funnel design and sales automation to turn opportunities into customers and scale your company\'s growth.' },
            ],
            ctaTitle: 'Attract, engage and convert',
            ctaText: 'Your digital strategy in expert hands. Let\'s grow your brand together.',
            ctaLabel: 'Boost your brand',
        },
        redes: {
            title: 'Networks & Infrastructure',
            subtitle: 'We design, install and manage secure, high-performance networks — from physical cabling to the Data Center — tailored to each company\'s needs.',
            blocks: [
                { title: 'Enterprise Networks', subtitle: 'Connectivity solutions', items: ['Design and deployment of LAN, WAN and SD-WAN networks', 'High-performance switching and routing', 'VLAN and network segmentation', 'Enterprise WiFi and mobility', 'Quality of Service (QoS)', 'High availability and redundancy', 'Monitoring and management'] },
                { title: 'Structured Cabling', subtitle: 'Reliable physical infrastructure', items: ['Voice and data cabling: Cat5e, Cat6, Cat6a and Cat7', 'Single-mode and multi-mode fiber optics', 'Conduit and ducting', 'Network point certification', 'Labeling and management', 'Professional documentation'] },
                { title: 'Infrastructure & Data Center', subtitle: 'Critical infrastructure for high availability', items: ['Telecommunications room design', 'Racks, cabinets and accessories', 'Regulated power, UPS and PDU', 'Climate control and environmental monitoring', 'Modernization and expansion'] },
            ],
            ctaTitle: 'Need to improve your network or infrastructure?',
            ctaText: 'Our team of specialists designs and deploys the ideal connectivity solution for your company.',
        },
        cctv: {
            title: 'Video Surveillance & CCTV',
            subtitle: 'Protect what matters most with video surveillance, access control and alarm systems for homes, businesses and industries.',
            servicios: [
                { title: 'Camera installation (CCTV)', text: 'Installation of video surveillance cameras for homes, businesses and industries.' },
                { title: 'Security equipment sales', text: 'Cameras, DVRs, NVRs, monitors and accessories.' },
                { title: 'Remote monitoring', text: 'Monitor from your phone, tablet or computer.' },
                { title: 'Maintenance', text: 'Preventive and corrective maintenance of video surveillance systems.' },
                { title: 'Upgrades & modernization', text: 'Upgrading and modernizing existing systems.' },
                { title: 'Access control', text: 'Access control systems with cards, fingerprint and facial recognition.' },
                { title: 'Security alarms', text: 'Installation of anti-theft and intrusion alarms.' },
            ],
            ctaTitle: 'Want to protect your home or business?',
            ctaText: 'We\'ll advise you on designing the ideal video surveillance and security system for your space.',
        },
        software: {
            title: 'Software & Consulting',
            subtitle: 'Intelligent solutions that transform your technology operations. Expert advice for complex enterprise environments and high-level solutions.',
            serviciosTitle: 'Featured services',
            servicios: [
                { title: 'Data & server migration', description: 'Secure transfer of your information without interrupting operations.' },
                { title: 'Systems virtualization', description: 'Virtual machines to optimize the use of your technology resources.' },
                { title: 'Process automation', description: 'We digitize repetitive tasks to improve operational efficiency.' },
                { title: 'IBM & Oracle consulting', description: 'Specialized advice on implementation, configuration and optimization.' },
            ],
            resultadosTitle: 'Expected results',
            resultadosSubtitle: 'Tangible benefits you\'ll experience by working with us.',
            resultados: [
                { title: 'Lower operating costs', description: 'We optimize your processes to minimize expenses and maximize return on investment.' },
                { title: 'Greater technological efficiency', description: 'We implement solutions that speed up your operations and improve performance.' },
                { title: 'Robust, scalable infrastructure', description: 'Solid foundations that grow with your business and adapt to your future needs.' },
            ],
            faqTitle: 'Frequently asked questions',
            faqs: [
                { q: 'How does the consulting process start?', a: 'We begin with an initial assessment of your needs and goals. Then we design a customized plan that fits your company and budget.' },
                { q: 'How long does it take to implement the solutions?', a: 'Time varies with the complexity of the project — typically from a few weeks to several months for larger implementations.' },
                { q: 'Do you offer post-implementation support?', a: 'Yes — all our services include a period of technical support and ongoing advice to ensure the solutions work optimally.' },
                { q: 'Do you work with companies of all sizes?', a: 'Yes — we adapt our solutions for both SMBs and large corporations, adjusting scope and budget to each need.' },
            ],
            ctaTitle: 'Ready to optimize your technology operations?',
            ctaText: 'Book a personalized consultation and discover how we can help.',
        },
        energias: {
            badge: 'Other services',
            title: 'Clean Energy',
            subtitle: 'Solar energy for home, business and industry. Cut your bill by up to 90% with certified engineering and sustainable solutions.',
            sectionTitle: 'Featured services',
            sectionSubtitle: 'Comprehensive photovoltaic solutions: design, installation, financing and monitoring.',
            servicios: [
                { title: 'Custom design', text: 'Engineering and sizing based on consumption and space.' },
                { title: 'Certified installation', text: 'Equipment and mounting with warranty and technical support.' },
                { title: 'Flexible financing', text: 'Options that adapt to your budget.' },
                { title: 'Monitoring', text: 'Real-time tracking of your system\'s performance.' },
            ],
            ctaButton: 'Get a quote',
        },
        equipos: {
            badge: 'Other services',
            title: 'Equipment & Supplies Sales',
            subtitle: 'Your all-in-one technology supplier: computers, video surveillance, networking and consumables — with expert advice and support.',
            sectionTitle: 'Our catalog',
            sectionSubtitle: 'Sourcing, supply and renewal of equipment for your business or home.',
            categorias: [
                { title: 'Computer equipment', subtitle: 'Power to work', items: ['Laptops & ultrabooks', 'Desktop PCs', 'Workstations', 'Servers', 'Monitors'] },
                { title: 'Video surveillance & security', subtitle: 'Reliable protection', items: ['IP & analog cameras', 'DVR & NVR', 'Access control', 'Alarms & accessories'] },
                { title: 'Networking & connectivity', subtitle: 'Limitless connection', items: ['Switches & routers', 'Access points', 'Cabling & patch panels', 'Fiber optics'] },
                { title: 'Consumables', subtitle: 'Keep running', items: ['Toners & cartridges', 'Paper & labels', 'Cables & adapters', 'Batteries', 'Storage media'] },
                { title: 'Accessories & peripherals', subtitle: 'Everything you need', items: ['Keyboards & mice', 'UPS units', 'Hard drives & SSDs', 'USB & RAM', 'Webcams & audio'] },
            ],
            benefitsTitle: 'Why buy from us?',
            benefits: [
                { title: 'Expert advice', text: 'We help you choose the right equipment for your needs and budget.' },
                { title: 'Original products', text: 'Equipment and consumables from recognized brands.' },
                { title: 'Tailored quotes', text: 'We prepare proposals based on what your project needs.' },
                { title: 'Delivery & support', text: 'Installation and after-sales technical support.' },
            ],
            ctaTitle: 'Need to equip your business?',
            ctaText: 'Tell us what you need and we\'ll prepare a custom quote.',
            ctaButton: 'Request a quote',
        },
        cookie: {
            textBefore: 'We use cookies to improve your browsing experience, analyze site traffic and personalize content. By clicking',
            acceptEmph: '“Accept”',
            textAfter: 'you consent to their use.',
            accept: 'Accept',
            reject: 'Reject',
        },
        footer: {
            tagline: 'Comprehensive solutions for your business, combining technology, strategy and energy.',
            techTitle: 'Technology',
            servicesTitle: 'Services',
            contactTitle: 'Contact',
            redes: 'Networks & Infrastructure',
            cctv: 'Video Surveillance & CCTV',
            software: 'Software & Consulting',
            marketing: 'Strategic Marketing',
            energias: 'Clean energy',
            equipos: 'Equipment Sales',
            downloadPortfolio: 'Download portfolio (PDF)',
            quienesSomos: 'About us',
            contactanos: 'Contact',
            rights: 'All rights reserved.',
        },
    },
};

export default translations;
